module.exports = __webpack_public_path__ + "static/media/company.aedd061f.png";